/**
 * GoogleAnalyticsCommand.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen, Henrique Campos for Ranj
 **/

import GoogleAnalyticsService from "../../../lib/html5-software-library/src/ranj/analytics/GoogleAnalyticsService";
import Config from "../core/config/Config";
import GoogleAnalyticsConfig from "./GoogleAnalyticsConfig";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";
import TrackString from "./TrackString";

export default class GoogleAnalyticsCommand {

	/**
	 * 
	 * @param {GoogleAnalyticsService} googleAnalyticsService 
	 * @param {GoogleAnalyticsConfig} googleAnalyticsConfig
	 * @param {Config} config
	 */
	constructor(googleAnalyticsService, googleAnalyticsConfig, config) {
		this._googleAnalyticsService = googleAnalyticsService;
		this._googleAnalyticsConfig = googleAnalyticsConfig;
		this._config = config;
	}


	execute(event) {
		const service = this._googleAnalyticsService;
		const params = event.params || {};
		switch (event.type) {

			case GoogleAnalyticsEvent.INIT:
				//Initialize the service
				const trackingID = this._googleAnalyticsConfig.trackingId;
				const enabled = this._googleAnalyticsConfig.isEnabled;
				const anonymousIp = this._googleAnalyticsConfig.isAnonymousIp;
				service.initialize(trackingID, enabled, anonymousIp);

				// set user scope custom dimensions
				const environment = this._config.getValue(Config.ENVIRONMENT);
				service.setUserProperty(TrackString.USER_ENVIRONMENT, environment);
				break;

			case GoogleAnalyticsEvent.USER:
				// See best practices of using User Id: https://support.google.com/analytics/answer/9213390?hl=en
				const userID = params;
				service.setUserID(userID);
				break;

			case GoogleAnalyticsEvent.USER_PROPERTY:
				service.setUserProperty(params.property, params.value);
				break;

			case GoogleAnalyticsEvent.PERSISTENT_VALUE:
				service.setPersistentValue(params.property, params.value);
				break;

			case GoogleAnalyticsEvent.SESSION_START:
				service.sendEvent(TrackString.EVENT_SESSION_START);
				break;

			case GoogleAnalyticsEvent.SESSION_END:
				service.sendEvent(TrackString.EVENT_SESSION_END);
				break;

			case GoogleAnalyticsEvent.EVENT:
				service.sendEvent(params.name, params.params);
				break;

			case GoogleAnalyticsEvent.ERROR:
				const description = params.description;
				const fatal = params.fatal;
				service.sendException(description, fatal);
				break;
		}
	}
}